<template>
  <div class="animated fadeIn">
    <div class="contacts__map">
      <div class="map">
        <div class="map__header">
          <div class="map__header-item medium" v-if="therapists">
            <div class="select__label">Therapist</div>
            <v-select class="select multiple clear flexible" v-model="selectedTherapist" multiple label="label" :options="therapists" @input="selectHandler" placeholder="Choose please a Therapist">
              <template v-slot:option="option">
                <div class="checkbox select">
                  <div class="checkbox__input" :class="selectedTherapist.some((e) => e.id === option.id) && 'active'">
                    <i class="fa fa-check"></i>
                  </div>
                </div>
                {{ option.label }}
              </template>
            </v-select>
          </div>
          <!-- <div class="map__header-item">
            <div class="date-picker__label">
              Date From
            </div>
            <Datepicker
              class="date-picker"
              @selected="value => datePickerHandler('start', value)"
              :value="datePicker.startDate"
              :clearButton="true"
            />
          </div>
          <div class="map__header-item">
            <div class="date-picker__label">
              Date To
            </div>
            <Datepicker
              class="date-picker"
              @selected="value => datePickerHandler('end', value)"
              :value="datePicker.endtDate"
              :clearButton="true"
            />
          </div> -->
          <div class="map__header-item map__header-item--min-height">
            <div class="select__label">Types</div>
            <v-select class="select flexible" :options="typesOptions" :value="typesValue" @input="typesHandler"/>
          </div>
          <div class="map__header-item map__header-item--state map__header-item--min-height">
            <div class="select__label">State</div>
            <v-select class="select flexible clear" :options="states" :value="stateValue" @input="stateHandler" placeholder="Select State"/>
          </div>
          <div class="map__header-item medium" v-if="regions">
            <div class="select__label">Region</div>
            <v-select class="select multiple clear flexible" multiple :options="regions" @input="selectRegionHandler" v-model="selectedRegion" placeholder="Select Region">
              <template v-slot:option="option">
                <div class="checkbox select">
                  <div class="checkbox__input" :class="selectedRegionIds.indexOf(option.id) >= 0 && 'active'">
                    <i class="fa fa-check"></i>
                  </div>
                </div>
                {{ option.label }}
              </template>
            </v-select>
          </div>
          <div class="map__header-item map__header-item--state map__header-item--min-height">
            <div class="select__label">Zip Code</div>
            <v-select class="select clear flexible" label="zipcode" :options="zipcodes" :value="zipValue" @input="zipHandler" placeholder="Select Zip Code"/>
          </div>
          <div v-if="zipValue" class="map__header-item map__header-item--state map__header-item--min-height">
            <div class="select__label">Slack Channel</div>
            <div>{{ slackValue }}</div>
          </div>
          <div v-if="showClearButton" class="map__header-item map__header-item--state map__header-item--min-height">
            <b-button @click="clearFilters" size="sm" variant="primary"><i class="fa fa-times-circle"></i> Clear</b-button>
          </div>
        </div>
        <div class="map__view">
          <gmap-map
            ref="gmap"
            :center="center"
            :zoom="9"
            style="width:100%;  height: 100%;"
          >
            <GmapCustomMarker
              v-for="(m, index) in markers"
              :marker="m.position"
              :key="index"
              @click.native="toggleInfoWindow(m, index)"
              @mouseenter="() => markerHover(m, index)"
              :z-index="m.zIndex || 50"
              :offsetX="0"
              :offsetY="15"
            >
              <div class="marker" @mouseenter="markerEnter(m)" @mouseleave="markerLeave(m)" :style="`background-color: ${m.color}`">
                <div class="marker__preview">
                  {{ m.patient }}
                </div>
                {{ m.abbr }}
              </div>
            </GmapCustomMarker>

            <gmap-info-window
              :options="infoOptions"
              :position="infoWindowPos"
              :opened="infoWinOpen"
              @closeclick="infoWinOpen=false"
            >
              <div v-html="infoContent"></div>
            </gmap-info-window>
          </gmap-map>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import GmapCustomMarker from 'vue2-gmap-custom-marker';
  import Datepicker from 'vuejs-datepicker';
  import {mapGetters} from "vuex";

  export default {
    name: 'CaseMap',
    components: {
      Datepicker,
      GmapCustomMarker
    },
    data() {
      return {
        typesValue: 'PoS',
        stateValue: '',
        typesOptions: [
          'PoS',
          'Teletherapy'
        ],
        stateOptions: [],
        selectedTherapist: [],
        selectedRegion: [],
        datePicker: {
          startDate: null,
          endDate: null,
        },
        center: {lat: 34.003985, lng: -118.109497},
        map: null,
        infoContent: '',
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -40
          }
        },
        markers: [],
        colors: [
          '#2ecdea',
          '#eaa583',
          '#94ea9d',
          '#eacc87',
          '#ea4c63',
          '#ea7ac0',
          '#c5eae1',
          '#99e5ea',
          '#80ea95',
          '#836eb0',
          '#eab9bd',
          '#a993ea',
          '#eac063',
          '#6b69ea',
          '#eab7dc',
          '#3cceea',
          '#9fea57',
        ],
        circles: [],
        activeCircle: [],
        zipValue: null,
        slackValue: null
      };
    },
    computed: {
      ...mapGetters([
        'therapists',
        'states',
        'zipcodes',
        'slackChannels',
        'isTherapistsLoaded',
        'isRegionsLoaded',
        'isStatesLoaded',
        'isZipsLoaded',
      ]),
      regions() {
        if (!this.zipcodes) return []
        return [...new Map(this.zipcodes.map(({region_id, region}) => [region_id, {id: region_id, label: region}])).values()]
      },
      selectedRegionIds() { return this.selectedRegion.map(r => r.id) },
      showClearButton() { return !!(this.stateValue || this.zipValue || this.typesValue != 'All' || this.selectedTherapist.length || this.selectedRegion.length)}
    },
    mounted() {

      if (!this.isStatesLoaded) this.getStates();

      if (!this.isRegionsLoaded) this.getRegions();

      if (!this.isZipsLoaded) this.getZipCodes();

    },
    methods: {
      // datePickerHandler(e, date) {
      //   if (e === 'start') {
      //     this.datePicker.startDate = date;
      //   } else {
      //     this.datePicker.endtDate = date;
      //   }
      //   this.getData();
      // },
      typesHandler(e) {
        this.typesValue = e;
        this.getData();
      },
      stateHandler(e) {
        this.stateValue = e;
        this.getData();
      },
      zipHandler(e) {
        this.zipValue = e ? e.zipcode : null;
        this.slackValue = e ? e.slack_channel : null;
        if (e) this.selectedRegion = [this.regions.find(r => r.id == e.region_id)]
        this.getData();
        if (this.zipValue) window.open(`https://www.google.com/maps/search/${this.zipValue}%20zip%20code`)
      },
      clearFilters() {
        this.zipValue = null
        this.slackValue = null
        this.stateValue = null
        this.selectedRegion = []
        this.selectedTherapist = []
        this.markers = []
        this.typesValue = 'All'
      },
      async getStates() {
          const endpoint = "/states";
          try {
              const r = await this.$newpetehealthapi.get(endpoint);
              this.stateOptions = r.data.map((e) => e.state).filter((e) => e);
              this.$store.commit('setStates', this.stateOptions);
          } catch (e) {
              console.log(e)
          }
      },
      async getRegions() {
        const endpoint = `/regions?agg=region`;
        try {
          const res = await this.$newpetehealthapi.get(endpoint, {
            paramsSerializer: params => qs.stringify(params)
          });
          const regions = res.data.map(item => {
            item.label = `${item.name}`;
            item.therapists = item.therapists.map((e) => {
                e.label = `${e.last_name}, ${e.first_name}`;
                return e;
            });
            return item;
          });
          this.$store.commit('setTherapists', this.getUniqueTherapists(regions));
          this.$store.commit('setRegions', regions);
        } catch (e) {
          return null;
        }
      },
      async getZipCodes() {
          const endpoint = "/zipcodes";
          try {
              const r = await this.$newpetehealthapi.get(endpoint);
              const zips = r.data.map(({zipcode, region_id, region, slack_channel, active}) => ({zipcode, region, region_id, slack_channel: slack_channel || (active ? 'Unassigned' : 'Out of Area')}));
              this.$store.commit('setZipCodes', zips.sort((a, b)=>a.zipcode - b.zipcode));
          } catch (e) {
              console.log(e)
          }
      },

      async getData() {
        this.infoWinOpen = false;
        const baseURL = process.env.VUE_APP_RUBY_URL + '/api/locations';
        const params = {};

        // if (this.datePicker.startDate) {
        //   params.from = formatDate(this.datePicker.startDate);
        // }

        // if (this.datePicker.endtDate) {
        //   params.to = formatDate(this.datePicker.endtDate);
        // }

        if (this.selectedTherapist.length) {
          params.tid = this.selectedTherapist.map((e) => e.id).join(',')
        }

        if (this.selectedRegion.length) {
          params.rid = this.selectedRegionIds.join(',');
        }

        if (this.stateValue) {
          params.sid = this.stateValue;
        }

        // if (this.zipValue) {
        //   params.zip = this.zipValue;
        // }

        if (Object.keys(params).length == 0) return

        if (this.typesValue) {
          params.leads = this.typesValue;
        }

        try {
          const res = await this.$newpetehealthapi.get(baseURL, { params });
          const therapists = {};
          this.markers = [];
          this.circles = [];

          if (res.data.length == 0) alert(`No cases meet your search criteria`)

          let colorIndex = 0;
          let therapistColors = {}

          res.data.map((item, index) => {
            item.id = index;
            item.position = { lng: +item.lon, lat: +item.lat };

            if (!therapists[item.tid]) {
              therapistColors[item.tid] = colorIndex;
              item.color = this.colors[colorIndex];
              therapists[item.tid] = [item];
              colorIndex++;
            } else {
              item.color = this.colors[therapistColors[item.tid]];
              therapists[item.tid].push(item)
            }

            return item;
          });

          for (let t in therapists) this.markers.push(...therapists[t])

          this.initMap();
        } catch (e) {
          this.markers = [];
          this.circles = [];
          this.initMap();
        }
      },

      initMap() {
        this.activeCircle.forEach(m => {
          m.setMap(null);
        });

        if (this.markers.length === 0) { return }

        this.$refs.gmap.$mapPromise.then((map) => {
          const bounds = new google.maps.LatLngBounds();
          const added = [[],[]];
          let addedCount = 2
          let startI = 0
          for (let m of this.markers) {
            if (this.selectedRegion.length) {
              if (this.zipValue) {
                if (startI == 0) startI = 1
                if (m.zip == this.zipValue) {
                  bounds.extend(m.position);
                  added[0].push(m);
                  continue
                }
              } else bounds.extend(m.position);
              let found = false
              for (let i = startI; i < addedCount; i++) {
                if (!added[i].length) {
                  added[i].push(m)
                  found = true
                } else if (added[i][0].region_id == m.region_id) {
                  added[i].push(m)
                  found = true
                }
                if (found) break
              }
              if (!found) {
                added.push([m])
                addedCount++
              }
            } else if (this.selectedTherapist.length) {
              if (!this.stateValue) bounds.extend(m.position);
              else if (m.state == this.stateValue) bounds.extend(m.position);
              let found = false
              for (let i = 0; i < addedCount; i++) {
                if (!added[i].length) {
                  added[i].push(m)
                  found = true
                } else if (added[i][0].tid == m.tid) {
                  added[i].push(m)
                  found = true
                }
                if (found) break
              }
              if (!found) {
                added.push([m])
                addedCount++
              }
            } else {
              bounds.extend(m.position)
              added[0].push(m);
            }
          }
          if (added[0].length == 0) this.markers.forEach(m => bounds.extend(m.position))

          // console.log('Added', added.map(a => a.length))
          // for (const a of added) this.getCircle(a)

          // this.circles.forEach(c => {
          //   const circle = new google.maps.Circle({
          //     strokeWeight: 0,
          //     fillColor: 'rgba(0, 7, 16, 0.3)',
          //     fillOpacity: 1,
          //     map: map,
          //     center: c.position,
          //     radius: c.distance
          //   });
          //   this.activeCircle.push(circle);
          // });
          map.fitBounds(bounds);
        });
      },

      getCircle(markers=[]) {
        if (!markers.length) return
        const circle = {
          maxLat: -10000,
          minLat: 10000,
          maxLng: -10000,
          minLng: 10000
        };

        markers.forEach(item => {
          const { lat, lng } = item.position;

          if (lat > circle.maxLat) {
            circle.maxLat = lat;
          }

          if (lat < circle.minLat) {
            circle.minLat = lat
          }

          if (lng > circle.maxLng) {
            circle.maxLng = lng;
          }

          if (lng < circle.minLng) {
            circle.minLng = lng
          }
        });

        // console.log(circle)

        const A = {
          x: circle.maxLat,
          y: circle.minLng
        };

        const B = {
          x: circle.minLat,
          y: circle.maxLng
        };

        // console.log(A)
        // console.log(B)

        const Ox = (circle.maxLat + circle.minLat) / 2;
        const Oy = (circle.maxLng + circle.minLng) / 2;
        this.circles.push({position: { lat: Ox, lng: Oy }, distance: (this.distance(Ox, Oy, circle.maxLat, circle.maxLng) * 1000) + 30})
      },
      distance(lat1, lon1, lat2, lon2) {
        let p = 0.017453292519943295;
        let c = Math.cos;
        let a = 0.5 - c((lat2 - lat1) * p)/2 +
          c(lat1 * p) * c(lat2 * p) *
          (1 - c((lon2 - lon1) * p))/2;

        return 12742 * Math.asin(Math.sqrt(a));
      },
      selectHandler() {
        this.getData();
      },
      getUniqueTherapists(regions) {
          if (regions.length === 0) regions = this.regions; // show therapist from all regions
          const therapists = regions.reduce((total, current) => {
              return [...total, ...current.therapists]
          }, []);
          return [...new Map(therapists.map(item =>[item.id, item])).values()]
      },
      filterTherapist(regions,id) {
          return regions.some((region) => {
              return region.therapists.some((e) => e.id === id);
          });
      },
      selectRegionHandler(regions) {
        // this.selectedRegion = regions.map(item => item.id);

        // if (this.selectedRegion.length) {
        //     this.selectedTherapist = this.selectedTherapist.filter((id) => this.filterTherapist(regions,id));
        // }

        // this.$store.commit('setTherapists', this.getUniqueTherapists(regions));
        this.getData();
      },

      toggleInfoWindow(marker, idx) {
        this.infoWindowPos = marker.position;
        this.infoContent = this.getInfoWindowContent(marker);
        if (this.currentMidx == idx) {
          this.infoWinOpen = !this.infoWinOpen;
        } else {
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      },

      markerLeave(marker) {
        this.markers = this.markers.map(item => {
          if (item.id === marker.id) {
            item.zIndex = 50;
          }
          return item;
        })
      },

      markerEnter(marker) {
        this.markers = this.markers.map(item => {
          if (item.id === marker.id) {
            item.zIndex = 999;
          }
          return item;
        })
      },

      getInfoWindowContent: function (marker) {
        return (`
         <div class="info-window">
          <div class="info-window__item">
            <div class="info-window__title">
              Therapist
            </div>
            <div class="info-window__value">
               ${marker.therapist}
            </div>
          </div>
          <div class="info-window__item">
            <div class="info-window__title">
              Patient
            </div>
            <div class="info-window__value">
              ${marker.patient}
            </div>
          </div>
          <div class="info-window__item">
            <div class="info-window__title">
              Address
            </div>
            <div class="info-window__value">
              ${marker.address}
            </div>
          </div>
        </div>
        `);
      },
    }
  };
</script>

<style lang="scss">
  .marker {
    width: 38px;
    height: 38px;
    box-shadow: 0 5px 10px rgba(51, 51, 51, 0.51);
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #00234e;
    font-size: 16px;
    text-transform: uppercase;
    font-family: 'Montserrat', sans-serif;
    border-radius: 50%;
    font-weight: 600;
    position: relative;
    z-index: 999999;
    &:hover {
      .marker__preview {
        transition-delay: .2s;
        opacity: 1;
      }
    }
    &__preview {
      box-shadow: 0 5px 10px rgba(0, 35, 78, 0.24);
      background-color: #ffffff;
      border-radius: 5px;
      padding: 10px 15px;
      color: #1c1f24;
      font-size: 12px;
      text-overflow: ellipsis;
      white-space: nowrap;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50px);
      transition: .3s;
      opacity: 0;
      pointer-events: none;
      &:before {
        content: "";
        position: absolute;
        border: 10px solid transparent; border-top: 10px solid #fff;
        left: 50%;
        transform: translateX(-50%);
        bottom: -17px;
      }
    }
  }

</style>
